import { createAction, props } from '@ngrx/store';

const loadHolidays = createAction('[Holidays] Load');
const loadHolidaysSuccess = createAction(
  '[Holidays] Load Success',
  props<{ holidays: any[] }>(),
);
const loadHolidaysFailure = createAction(
  '[Holidays] Load Failure',
  props<{ error: any }>(),
);

export const HOLIDAY_ACTIONS = {
  loadHolidays,
  loadHolidaysSuccess,
  loadHolidaysFailure,
};
